module.exports = __webpack_public_path__ + "img/16.d6101c88.png";